import React, { Component } from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Checkbox,
	Typography,
	Popover,
	MenuList,
	MenuItem,
	ListItemIcon,
} from '@material-ui/core';
import ContentData from '../types/ContentData';

const styles = (theme: Theme) => createStyles({
	borderBlue: {
		color: '#1D7DEA !important',
		border: '1px solid #1D7DEA',
		fontSize: '0.875rem'
	},
	dataManipulateIcons: {
		'&>:nth-child(1)': {
			paddingRight: 10,
		},
		'& img': {
			cursor: 'pointer'
		}
	},
	noSelectedText: {
		'&>:nth-child(1)': {
			paddingLeft: 17,
			color: 'rgb(51 51 51)'
		}
	},
	paper: {
		margin: '18px 0px'
	},
	SelectCheckedCheckbox: {
		backgroundColor: '#1d7dea!important',
		border: '1px solid #1d7dea !important',
		borderRadius: 2,
		color: '#99a1a7',
		'&::before': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: '-1px',
			left: 4,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
	checkedCheckbox: {
		backgroundColor: '#1d7dea!important',
		border: '1px solid #1d7dea !important',
		borderRadius: 2,
		color: '#99a1a7',
		'&::before': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: 1,
			left: 6,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
	SelectcheckedCheckbox: {
		backgroundColor: '#1d7dea!important',
		border: '1px solid #1d7dea !important',
		borderRadius: 2,
		color: '#99a1a7',
		width: '16px',
		height: '16px',
		padding: 0,
		'&::after': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: '1px',
			left: 6,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
	SelectCheckbox: {
		padding: 0,
		top: 0,
		left: 6,
		width: 20,
		height: 20,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		border: '1px solid #B2B2B2',
		borderRadius: 4,
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		}
	},
	checkBoxElement: {
		padding: '0px 7px',
		top: 0,
		width: 20,
		height: 20,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		border: '1px solid #B2B2B2',
		borderRadius: 4,
		margin: '-4px 14px 0px 16px',
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		},
		'& span:nth-child(1)': {
            width: 24,
            zIndex: 9
        }
	},

	checkboxLabel: {
		fontSize: 18,
		color: '#363636',
	},
	formControlLabel: {
		marginBottom: 6
	},
	lightGrey: {
		color: 'rgb(102 102 102)'
	},
	listItemIcon: {
		marginRight: -4,
		'& :first-child': {
			top: 0,
			height: 14,
			width: 14,
			left: 2
		},
		'&>:first-child::after': {
			top: -1,
			left: 4
		}
	},
	paddingZero: {
		paddingTop: 0,
		paddingBottom: 0
	},
	popoverRoot: {
		marginLeft: -20
	},
	contentFilter: {
		paddingTop: theme.spacing.unit * 2,
	},
	checkbox: {
		padding: 0,
		top: 0,
		left: 6,
		width: 16,
		height: 16,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		border: '1px solid #1D7DEA',
		borderRadius: 2,
		marginRight: 14,
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		}
	},
	primaryColor: {
		color: 'rgb(29 125 234)'
	},
	height1X: {
		height: 76
	},
	paddingLeft: {
		paddingLeft: 50
	},
	cursorPointer: {
		cursor: 'pointer',
		'& :hover': {
			color: '#417dea'
		}
	},
	paddingSm: {
		padding: '10px 20px'
	},
	textRight: {
		textAlign: 'right',
	},
	greyColor: {
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: 16,
		lineHeight: '24px',
		display: 'flex',
		alignItems: 'center',
		color: '#333333'
	},
	inlineBlock: {
		display: 'inline-block'
	},
	filterChip: {
		verticalAlign: 'super',
		margin: '4px 4px',
		backgroundColor: 'rgb(244 244 244)',
		border: '1px solid rgb(235, 235, 235)',
		'& svg': {
			color: 'rgb(153, 153, 153)'
		}
	},
	filterListBlock: {
		'& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
			opacity: 12,
			width: 10,
			backgroundColor: '#eee'
		},
		'& .ps__thumb-y, .ps__rail-y:hover > .ps__thumb-y': {
			backgroundColor: '#999',
			width: 6
		}
	},
	relativeBox: {
		position: 'relative',
	},
	leftSideBar: {
		'&>:first-child': {
			marginTop: 84
		}
	},
	tableView: {
		display: 'table'
	},
	marginMD: {
		marginTop: 0
	},
	fixedSection: {
		background: '#fff',
		position: 'sticky',
		top: 'calc(64px + 129px)',
		alignContent: 'space-between',
		alignItems: 'flex-start',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'flex-start',
		zIndex: 10,
		width: '100%',
		border: '1px solid #c6c6c6',
		boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2)',
		height: 'auto',
		padding: '6px',

	},
	fixedSectionScroll: {
		background: 'rgb(255 255 255)',
		boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
		boxSizing: 'border-box',
		borderRadius: 8,
		top: 'calc(64px + 261px)',
		alignContent: 'space-between',
		alignItems: 'flex-end',
		display: 'flex',
		flexWrap: 'wrap',
		zIndex: 10,
		width: '100%',
		minHeight: 50,
		padding: '0px 8px',
		marginTop: '24px'
	},
	selectOption: {
		marginLeft: '26px',
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
		'& input':{
			zIndex: 1,
		}
	},
		root: {
		justifyContent: 'center',
		display: 'block'
	},
	marginTop1x: {
		marginTop: 12
	},
	marginTop2x: {
		marginTop: 20
	},
	disabledBox: {
		opacity: 0.5,
		cursor: "not-allowed"
	}
});

//@ts-ignore
interface WithContentProps extends WithStyles<typeof styles> {
	classes: any,
	selectedQuestions: ContentData[],
	fromTestPaper: boolean,
	handleSelectAll: Function,	
	fromCourseMangement?: boolean,
	isSelectAllRequired: Boolean,
	totalQuestionCount: number;
    currentPageNumber: number;
    questionReviews: any[];
	checkedChallenges: string[];
	selectAllChallenges: boolean;
	issueCategory: string[];
}

interface WithContentStates {
	anchorEl: any,
	setAnchorEl: any,
	isAllItemSelected: boolean,
	selectAllContent: boolean,
    questionStatusStore: boolean;
	open: boolean;
}

class CheckBoxPopOver extends Component<WithContentProps, WithContentStates>{

	constructor(props: WithContentProps) {
		super(props);
		this.state = {
			anchorEl: null,
			setAnchorEl: null,
			isAllItemSelected: false,
			selectAllContent: false,
            questionStatusStore: false,
			open: false,
		};
		this._selectAllContent = this._selectAllContent.bind(this);
	}

	doSelectAll = (checked: boolean, currentPageNumber = 0) => {
        this.props.handleSelectAll(checked, currentPageNumber)
	}

	_selectAllContent(e: any, checked: boolean) {
	    this.setState({ questionStatusStore : !this.state.questionStatusStore}, () => {
            if (!this.state.questionStatusStore){
                this.setState({selectAllContent: false}) 
            }
            this.doSelectAll(this.state.questionStatusStore, this.props.currentPageNumber)
        })
		this.setState({ open:false})
	}

	selectAllItem = () => {
		this.setState({
			selectAllContent: !this.state.selectAllContent
		}, () => {

            this.setState({ questionStatusStore : this.state.selectAllContent })
			this.doSelectAll(this.state.selectAllContent)
		});
		this.setState({ open: false})
	}

	selectPageItem = (e: any) => {
		this.setState({
			isAllItemSelected: !this.state.isAllItemSelected,
			anchorEl: e.currentTarget
		});
        this.isCurrentPageChecked();
		const checkedCondition = !!(this.props.selectAllChallenges || (this.props.checkedChallenges.length && (this.props.checkedChallenges.length === this.props.totalQuestionCount)))
		this.setState({ selectAllContent : checkedCondition, open: true});
	}

    isCurrentPageChecked = (checked?: boolean) => {
        let count = 0;
		const challenges = new Set([...this.props.checkedChallenges]);
		this.props.questionReviews.forEach((review : any) => {
			const id:string = review._id;
			if (challenges.has(id)) {
				count++;
			}
		})
		if (count && count === this.props.questionReviews.length || this.props.selectAllChallenges) {
			this.setState({ questionStatusStore : true });
		} else {
			this.setState({ questionStatusStore : false });
		}
    }

    onPopoverClick = () => {
        this.isCurrentPageChecked();
		this.setState({ open: !this.state.open });
    }

	multipleSelectOption = () => {
		const { classes, fromTestPaper, totalQuestionCount } = this.props;
		const { anchorEl,
			isAllItemSelected,
			selectAllContent,
            questionStatusStore
		} = this.state;
		return (<Popover
			className={classes.marginTop1x}
			classes={{ paper: classes.popoverRoot }}
			id="simple-menu"
			elevation={8}
			anchorEl={anchorEl}
			anchorReference='anchorEl'
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
			open={this.state.open}
            onClick={this.onPopoverClick}
			onClose={() => this.setState({
				isAllItemSelected: !this.state.isAllItemSelected
				, setAnchorEl: null
			})}
		>
            <MenuList classes={{ padding: classes.paddingZero }}>
				<MenuItem>
					<ListItemIcon classes={{ root: classes.listItemIcon }}>
						<Checkbox
							onChange={this._selectAllContent}
							checked={questionStatusStore}
							classes={{
								root: classes.checkbox,
								checked: classes.SelectCheckedCheckbox,
								colorPrimary: classes.primaryColor,
								disabled: classes.disabledBox,
							}}
							disabled={this.props.selectAllChallenges}
							color="primary" disableRipple />
					</ListItemIcon>
					<Typography variant="inherit" color="secondary" classes={{ colorSecondary: classes.lightGrey }}>
						Select Item on this Page ({this.props.questionReviews.length})
					</Typography>
				</MenuItem>
				{(!this.props.fromTestPaper || this.props.fromCourseMangement) &&
					<MenuItem>
						<ListItemIcon classes={{ root: classes.listItemIcon }}>
							<Checkbox
								onChange={this.selectAllItem}
								checked={selectAllContent}
								disabled={this.props.issueCategory.length !== 0 && this.props.issueCategory.length !== 7}
								classes={{
									root: classes.checkbox,
									checked: classes.SelectCheckedCheckbox,
									colorPrimary: classes.primaryColor,
									disabled: classes.disabledBox,
								}}
								color="primary" disableRipple />
						</ListItemIcon>
						<Typography variant="inherit" color="secondary" classes={{ colorSecondary: classes.lightGrey }}>
							Select All Search Result ({totalQuestionCount})
					</Typography>
					</MenuItem>
				}
			</MenuList>
		</Popover>
		);
	}

	render() {
		const { classes, fromTestPaper, isSelectAllRequired = true, totalQuestionCount, currentPageNumber } = this.props;

		return (
			<Grid id="content-list-container" container alignItems="center">
				<Grid item xs={8}>
					<Grid className={classes.paper}>
						<Grid className={classes.selectOption}>
							{isSelectAllRequired &&
								<>
									<Checkbox
                                        onChange={this.selectPageItem}
                                        checked={this.props.selectAllChallenges || !!(totalQuestionCount && (this.props.checkedChallenges.length === totalQuestionCount))}
                                        id={'all-check-box'}
                                        classes={{
                                            root: classes.SelectCheckbox,
                                            checked: classes.SelectcheckedCheckbox,
                                            colorPrimary: classes.primaryColor
                                        }}

                                        color="primary" />
									<span className={classes.checkLabel}>{this.props.selectAllChallenges ? totalQuestionCount : this.props.checkedChallenges.length} / {totalQuestionCount} Selected</span>
								</>}
							{this.multipleSelectOption()}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		);
	}
}

// @ts-ignore
export default (withStyles(styles)(CheckBoxPopOver));
